import { useEffect } from 'react'

// UX41: bottom-center prompt that offers to save an anonymous
// (ephemeral) user's progress with Google. Appears once after their
// 3rd vote; dismiss snoozes it until they've cast 10 more. The caller
// (Home.jsx) manages the state and passes onSave / onDismiss.
//
// Styled like the quill toast — same bottom position, same card
// shape — so it feels like part of the same ambient-feedback system,
// not a new modal pattern.
export function UpgradePrompt({ voteCount, onSave, onDismiss }) {
  // Dismiss on Escape so a keyboard user can bail without clicking.
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onDismiss() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onDismiss])

  return (
    <div className="upgrade-prompt" role="dialog" aria-live="polite">
      <div className="upgrade-prompt-body">
        <div className="upgrade-prompt-head">
          You&rsquo;ve voted {voteCount} times
        </div>
        <div className="upgrade-prompt-sub">
          Save your account with Google so your votes travel with you.
        </div>
      </div>
      <div className="upgrade-prompt-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onDismiss}
        >
          Later
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSave}
        >
          Save with Google
        </button>
      </div>
    </div>
  )
}
